import { z } from 'zod';

/**
 * Generic acknowledgement envelope returned by mutation endpoints that don't
 * echo back the affected resource (`Success` in the OpenAPI spec). Shared
 * across apps to avoid every domain redeclaring the same three fields.
 */
export const zodSuccessResponseSchema = z.object({
  code: z.number().int(),
  message: z.string(),
  requestId: z.uuid().nullish(),
});

export type SuccessResponse = z.infer<typeof zodSuccessResponseSchema>;
